module.exports = __webpack_public_path__ + "static/media/nido.d6881707.png";